import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemSecondaryAction,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import TogoIcon from "@material-ui/icons/DirectionsRun";
import LineItem from "components/LineItem";
import useStyles from "./styles";

const OrderPanel = ({
  isOpen,
  togglePanel,
  order: { id, created_at, completed_at, tender_type, total_money, to_go, receipt_url, line_items, customer },
}) => {
  const classes = useStyles();

  const title = customer ? `Order: ${customer.display_name}` : "Order";
  return (
    <Drawer classes={{ paper: classes.drawer }} open={isOpen} anchor="right" onClose={togglePanel}>
      <Grid container justify="flex-end">
        <IconButton onClick={togglePanel}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <List className={classes.orderContainer}>
        <ListSubheader className={classes.subheader}>
          {
            <>
              <Typography variant="h6" className={classes.subheaderTitle} data-id={id} noWrap>
                {title}
              </Typography>
              <Typography variant="subtitle1" className={classes.totalAmount}>
                {total_money}
              </Typography>
              <ListItemText secondary={`Opened: ${moment(created_at).format("L LT")}`} />
              <Typography variant="subtitle2">{tender_type}</Typography>
              {to_go ? (
                <ListItemSecondaryAction>
                  <TogoIcon fontSize="large" />
                </ListItemSecondaryAction>
              ) : null}
            </>
          }
        </ListSubheader>
        <Divider variant="middle" />
        {line_items.map((item) => (
          <LineItem key={`${id}-${item.item_id}`} id={id} line_item={item} />
        ))}
        <Divider className={classes.margin14} variant="middle" />
        <ListItem>
          <ListItemText secondary={`Completed: ${moment(completed_at).format("L LT")}`} />
        </ListItem>
      </List>
      <List>
        <Grid container justify="center">
          <a href={receipt_url} className={classes.link} target="blank">
            Receipt
          </a>
        </Grid>
      </List>
    </Drawer>
  );
};

OrderPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    to_go: PropTypes.bool,
    created_at: PropTypes.string,
    line_items: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default OrderPanel;
